import React from 'react'
import ReceiptContent from './ReceiptContent'

const ReffedRender = React.forwardRef((props, ref) => {
  return <div ref={ref}>
    <ReceiptContent {...props} />
  </div>
})

export default ReffedRender
